<template>
  <div class="list_div">
    <!--导航面包屑-->
    <page-header></page-header>
<!--    <div style="display: flex;align-items: center;margin-top: 10px;">-->
<!--      <span style="width: 100px">字典名称：</span>-->
<!--      <el-input :value="titleName" auto-complete="off" :disabled="true" :size="size"></el-input>-->
<!--    </div>-->
    <!--工具栏-->
    <div class="toolbar" style="float:left;padding-top:10px;">
      <el-form :inline="true" :model="filters" :size="size">
        <el-form-item>
          <el-input v-model="filters.name" placeholder="输入名称、编码" prefix-icon="el-icon-search" clearable></el-input>
        </el-form-item>
        <el-form-item>
          <kt-button icon="fa fa-search" :label="$t('action.search')" perms="sys:dict" type="primary"
                     @click="select"/>
        </el-form-item>
        <el-form-item>
          <kt-button icon="el-icon-back" label="返回" size="mini" @click="handleBack(null)"/>
        </el-form-item>
        <el-form-item>
          <kt-button icon="fa fa-plus" :label="$t('action.add')" perms="sys:dict:edit" type="primary"
                     @click="handleAdd(null)"/>
        </el-form-item>
      </el-form>
    </div>

    <div class="page-container">
      <div class="header-container_list">
        <img src="/static/img/sys/listIcons/dict.png">
        <label class="header_title_list"><span>字典明细 -- {{titleName}}</span></label>
      </div>
    <!--表格内容栏-->
    <el-table :data="dictDetailData.list" stripe size="mini" style="width: 100%;"
              @findDictDetailData="findDictDetailData" @selection-change="selectionChange"
              v-loading="loading" :element-loading-text="$t('action.loading')"
              row-key="id">
      <el-table-column type="selection" width="40"></el-table-column>
      <el-table-column
        header-align="center" align="center" width="100" label="序号">
        <template slot-scope="scope"><span>{{scope.$index + 1}} </span></template>
      </el-table-column>
      <el-table-column
        prop="name" header-align="center" align="center" label="名称">
      </el-table-column>
      <el-table-column
        prop="code" header-align="center" align="center" label="字典编码">
      </el-table-column>
      <el-table-column
        prop="description" header-align="center" align="center"
        :show-overflow-tooltip="true" label="描述">
      </el-table-column>
      <el-table-column
        prop="valid" header-align="center" align="center"
        :show-overflow-tooltip="true" label="是否有效" :formatter="formatValid">
      </el-table-column>
      <el-table-column
        prop="updateTime" header-align="center" align="center"
        :show-overflow-tooltip="true" label="更新时间">
      </el-table-column>

      <el-table-column header-align="center" align="center" :label="$t('action.operation')" width="300">
        <template slot-scope="scope">
          <el-button icon="el-icon-plus" size="mini" circle :title="'新增'" perms="sys:dict:edit"
                     @click="handleAdd(scope.row)"/>
          <el-button icon="el-icon-view" size="mini" circle :title="'查看'" perms="sys:dict:edit"
                     @click="handleView(scope.row)"/>
          <el-button icon="el-icon-edit" size="mini" circle :title="'编辑'" perms="sys:dict:edit"
                     @click="handleEdit(scope.row)"/>
          <el-button type="primary" icon="el-icon-delete" size="mini" circle :title="'删除'" perms="sys:dict:edit"
                     @click="handleDelete(scope.row)"/>
          <el-button icon="el-icon-arrow-up" size="mini" circle :title="'上移'" perms="sys:dict:edit"
                     @click="handleMoveUp(scope.row)"/>
          <el-button icon="el-icon-arrow-down" size="mini" circle :title="'下移'" perms="sys:dict:edit"
                     @click="handleMoveDown(scope.row)"/>
        </template>
      </el-table-column>
    </el-table>

    <div class="toolbar" style="padding:10px;">
      <kt-button :label="$t('action.batchDelete')" perms="sys:dict:edit" :size="size" type="primary"
                 @click="handleDelete(null)"
                 :disabled="this.selections.length===0" style="float:left;"/>
      <el-pagination layout="total, prev, pager, next, jumper" @current-change="refreshPageRequest"
                     :current-page="pageRequest.pageNum" :page-size="pageRequest.pageSize"
                     :total="dictDetailData.totalCount"
                     style="float:right;">
      </el-pagination>
    </div>
    </div>

    <!--新增编辑界面-->
    <el-dialog :title="operation?'新增':'编辑'" width="40%" :visible.sync="editDialogVisible" :close-on-click-modal="false">
      <el-form :model="dataForm" label-width="80px" :rules="dataFormRules" ref="dataForm" :size="size">
        <el-form-item label="ID" prop="id" v-if="false">
          <el-input v-model="dataForm.id" :disabled="true" auto-complete="off"></el-input>
        </el-form-item>
        <el-form-item label="dictId" prop="dictId" v-if="false">
          <el-input v-model="dataForm.dictId" :disabled="true" auto-complete="off"></el-input>
        </el-form-item>

        <el-form-item label="父级" prop="parentLevel" v-if="showStatusOne">
          <el-input v-model="parentLevel" auto-complete="off" :disabled="true" type="text"></el-input>
        </el-form-item>
        <el-form-item label="父级" prop="levelName" v-if="showStatusTwo">
          <el-input v-model="levelName" auto-complete="off" :disabled="true" type="text"></el-input>
        </el-form-item>

        <el-form-item label="名称" prop="name">
          <el-input v-model="dataForm.name" auto-complete="off"></el-input>
        </el-form-item>
        <el-form-item label="编码" prop="code">
          <el-input v-model="dataForm.code" auto-complete="off"></el-input>
        </el-form-item>
        <el-form-item label="系统定义" prop="isReserved" align="left">
          <el-switch v-model="dataForm.isReserved" active-text="是" inactive-text="否"></el-switch>
        </el-form-item>
        <el-form-item label="标记" prop="tag">
          <el-input v-model="dataForm.tag" auto-complete="off"></el-input>
        </el-form-item>
        <el-form-item label="是否有效" prop="isValid" align="left">
          <el-switch v-model="dataForm.isValid" active-text="是" inactive-text="否"></el-switch>
        </el-form-item>
        <el-form-item label="描述 " prop="description">
          <el-input v-model="dataForm.description" auto-complete="off" type="textarea"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button :size="size" @click.native="editDialogVisible = false">{{$t('action.cancel')}}</el-button>
        <el-button :size="size" type="primary" @click.native="submitForm" :loading="editLoading">
          {{$t('action.submit')}}
        </el-button>
      </div>
    </el-dialog>

    <!--查看界面-->
    <el-dialog title="字典详情查看" width="40%" :visible.sync="viewDictDetailEnable" :close-on-click-modal="false">
      <el-form :model="dataForm" label-width="80px" ref="dataForm" :size="size">
        <el-form-item label="名称" prop="name">
          <el-input v-model="dataForm.name" :disabled="true"></el-input>
        </el-form-item>
        <el-form-item label="编码" prop="code">
          <el-input v-model="dataForm.code" auto-complete="off" :disabled="true"></el-input>
        </el-form-item>
        <el-form-item label="标记" prop="tag">
          <el-input v-model="dataForm.tag" auto-complete="off" :disabled="true"></el-input>
        </el-form-item>
        <el-form-item label="是否有效" prop="valid">
          <el-input v-model="validStatus" auto-complete="off" :disabled="true"></el-input>
        </el-form-item>
        <el-form-item label="创建时间" prop="createTime">
          <el-input v-model="dataForm.createTime" auto-complete="off" :disabled="true"></el-input>
        </el-form-item>
        <el-form-item label="更新时间" prop="updateTime">
          <el-input v-model="dataForm.updateTime" auto-complete="off" :disabled="true"></el-input>
        </el-form-item>
        <el-form-item label="描述 " prop="description">
          <el-input v-model="dataForm.description" auto-complete="off" type="textarea" :disabled="true"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button :size="size" @click.native="viewDictDetailEnable = false">{{$t('action.close')}}</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
  import KtButton from "@/views/Core/KtButton";
  import KtTable from "@/views/Core/KtTable"
  import {format} from "@/utils/datetime";
  import TableTreeColumn from "@/views/Core/TableTreeColumn";
  import PageHeader from "@/views/Biz/Common/PageHeader";

  var dictId = 0;
  var parentId = 0;
  export default {
    components: {
      KtButton,
      KtTable,
      PageHeader,
      TableTreeColumn
    },
    data() {
      return {
        size: 'small',
        loading: false,
        filters: {
          name: ''
        },
        pageRequest: {pageNum: 1, pageSize: 10},
        dictDetailData: [],
        dialogVisible: false,
        operation: false, // true:新增, false:编辑
        editDialogVisible: false, // 新增编辑界面是否显示
        viewDictDetailEnable: false,//查看详情界面是否显示
        editLoading: false,
        dataFormRules: {
          name: [
            {required: true, message: '请输入名称', trigger: 'blur'}
          ],
          code: [
            {required: true, message: '请输入编码', trigger: 'blur'}
          ]
        },
        // 新增编辑界面数据
        dataForm: {},
        titleName: '',
        levelName: '',
        parentLevel: '',
        showStatusOne: true,
        showStatusTwo: true,
        validStatus: '',
        selections: []  // 列表选中列
      }
    },

    methods: {
      // 获取分页数据
      findDictDetailData: function () {
        this.loading = true;
        let params = {
          "dictId": dictId,
          "keywords": this.filters.name,
          "pageNum": this.pageRequest.pageNum,
          "pageSize": this.pageRequest.pageSize
        };
        this.$api.dict.dictDetailList(params).then(res => {
          this.dictDetailData = res.data;
          this.loading = false;
        })
      },
      select:function () {
        this.pageRequest.pageNum = 1;
        this.findDictDetailData();
      },

      // 批量删除
      handleDelete: function (data) {
        let ids = this.selections.map(item => item.id);
        this.$confirm('确认删除吗？', '提示', {}).then(() => {
          let idsStr = "";
          if (data != null) {
            idsStr = data.id
          } else {
            idsStr = ids.join(",");
          }
          let param = {"ids": idsStr};
          this.$api.dict.dictDetailDelete(param).then((res) => {
            if (res.code == 200) {
              this.$message({message: '删除成功', type: 'success'});
              this.findDictDetailData()
            } else {
              this.$message({message: '删除失败, ' + res.msg, type: 'error'})
            }
          })
        })
      },
      // 显示新增界面
      handleAdd: function (data) {
        this.parentLevel = this.titleName;
        parentId = 0;
        if (data != null) {
          this.parentLevel = data.name;
          parentId = data.id
        }
        this.editDialogVisible = true;
        this.operation = true;
        this.showStatusOne = true;
        this.showStatusTwo = false;
        this.dataForm = {
          id: 0,
          name: '',
          code: '',
          description: '',
          parent: parentId,
          dictId: dictId,
          isReserved: true,
          isValid: true,
          isLeaf: false
        }
      },
      // 显示编辑界面
      handleEdit: function (params) {
        this.editDialogVisible = true;
        this.operation = false;
        let param = {"id": params.id};
        this.$api.dict.dictDetailEdit(param).then(res => {
          if (res.code == 200) {
            this.dataForm = res.data;
            this.dataForm.parent = res.data.parentId
          }
        });
        if (params.parentId == 0) {
          this.parentLevel = this.titleName;
          this.showStatusTwo = false;
          this.showStatusOne = true;
        }
        if (params.parentId != 0) {
          let firstParam = {"id": params.parentId};
          this.$api.dict.dictDetailEdit(firstParam).then(res => {
            if (res.code == 200) {
              this.levelName = res.data.name
            }
          });
          this.showStatusTwo = true;
          this.showStatusOne = false;
        }
      },
      // 编辑
      submitForm: function () {
        this.$refs.dataForm.validate((valid) => {
          if (valid) {
            this.$confirm('确认提交吗？', '提示', {}).then(() => {
              this.editLoading = true;
              let params = Object.assign({}, this.dataForm);
              params.dictId = dictId;
              this.$api.dict.saveDictDetail(params).then((res) => {
                if (res.code == 200) {
                  this.$message({message: '操作成功', type: 'success'});
                  this.editDialogVisible = false;
                  this.$refs['dataForm'].resetFields()
                } else {
                  this.$message({message: '操作失败, ' + res.msg, type: 'error'})
                }
                this.editLoading = false;
                this.findDictDetailData(dictId)
              })
            })
          }
        })
      },
      //查看
      handleView: function (params) {
        if (params.valid == true) {
          this.validStatus = "是";
        } else {
          this.validStatus = "否";
        }
        this.viewDictDetailEnable = true;
        let id = {"id": params.id};
        this.$api.dict.dictDetailEdit(id).then(res => {
          if (res.code == 200) {
            this.dataForm = res.data;
          }
        });
      },
      // 时间格式化
      dateFormat: function (row, column, cellValue, index) {
        return format(row[column.property])
      },
      //判断字典是否有效
      formatValid: function (row, column, cellValue) {
        if (cellValue == true) {
          return '是';
        } else if (cellValue == false) {
          return '否';
        }
      },
      // 换页刷新
      refreshPageRequest: function (pageNum) {
        this.pageRequest.pageNum = pageNum;
        this.findDictDetailData()
      },
      selectionChange: function (selections) {
        this.selections = selections
        this.$emit('selectionChange', {selections: selections})
      },
      // 上移
      handleMoveUp(row) {
        var params = {clazz: 'SysDictDetail', id: row.id, param: ''};
        this.$api.commonPage.moveUp(params).then((res) => {
          if (res.code === 200) {
            this.findDictDetailData(dictId);
            this.$message({message: "上移成功！", type: "success"});
          }
        });
      },
      // 下移
      handleMoveDown(row) {
        var params = {clazz: 'SysDictDetail', id: row.id, param: ''};
        this.$api.commonPage.moveDown(params).then((res) => {
          if (res.code === 200) {
            this.findDictDetailData(dictId);
            this.$message({message: "下移成功！", type: "success"});
          }
        });
      },
      handleBack(){
        this.$router.push({path: '/sys/dict', name: '系统字典'})
      }
    },
    mounted() {
      this.titleName = sessionStorage.getItem("name");
      dictId = sessionStorage.getItem("dictId");
      this.findDictDetailData(dictId);
      $(document.body).css({
        "overflow-x": "hidden",
        "overflow-y": "hidden"
      });
      // $(".main-content").css({
      //   "overflow-x": "auto",
      //   "overflow-y": "auto"
      // });
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/Sys/DictDetail.vue